import { useBuildingStore } from "@/hooks/useBuildingStore";
import { usePermissions } from "@/hooks/usePermissions";
import { useContacts } from "./queries";

function contactScope(
  buildingId: number | null,
  projectId: number | null,
  buildingOrgId: string | undefined
) {
  if (buildingId === null || projectId === null || buildingOrgId === undefined) return null;
  return { buildingId, projectId, buildingOrgId };
}

/** Optional contact details follow the same project permission as the Contacts page. */
export function useProjectContacts(
  buildingId: number | null,
  projectId: number | null,
  enabled = true
) {
  const perms = usePermissions();
  const buildings = useBuildingStore();
  const building = buildingId === null ? undefined : buildings.getById(String(buildingId));
  const scope = contactScope(buildingId, projectId, building?.base.org_id);
  const allowed = enabled && scope !== null && perms.canViewContacts(scope);
  const query = useContacts(allowed ? buildingId : null, allowed ? projectId : null);
  return { ...query, allowed };
}
